export function getCorpList(data) {
    let { getCorpListRequest, getCorpListError, getCorpListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/corp/list',
        this.createBundle('app/corp/list', { data: data }, this.GET, getCorpListRequest, getCorpListResult, getCorpListError)
    )
}
